// extracted by mini-css-extract-plugin
export default {"secondSection":"SecondSection_secondSection__QtJgA","servicesContainer":"SecondSection_servicesContainer__buIME"};